const budgetStatusConstants = Object.freeze({
  ACTIVE: 'active',
  CLOSED: 'closed',
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  REJECTED: 'rejected',
  APPROVED: 'approved',
  OVER_BUDGET: 'over_budget'
});

const budgetProcurementTypeConstants = Object.freeze({
  BUDGET_ITEM: 'budget_item',
  PURCHASE_ORDER: 'purchase_order'
});

export {
  budgetStatusConstants,
  budgetProcurementTypeConstants,
};
